import React from "react";

/**
 * Small level badge showing tier icon + level number.
 * Rendered next to every employee name on the schedule + roster.
 * `size="sm"` for tight UI (schedule grid), `size="md"` for the farm page.
 */
const TIER_STYLE = [
  null, // no level 0
  { icon: "🌱", cls: "bg-lime-100 text-lime-800 border-lime-300"      }, // Sprout
  { icon: "🌿", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" }, // Sapling
  { icon: "🚜", cls: "bg-yellow-100 text-yellow-800 border-yellow-300"    }, // Farmhand
  { icon: "🌻", cls: "bg-amber-100 text-amber-800 border-amber-300"       }, // Farmer
  { icon: "🌾", cls: "bg-orange-100 text-orange-800 border-orange-300"    }, // Harvest Master
  { icon: "👑", cls: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300" }, // Legendary Farmer
];

export default function LevelBadge({ level, size = "sm", showLabel = false }) {
  if (!level || !level.level) return null;
  const style = TIER_STYLE[level.level] || TIER_STYLE[1];
  const sizeCls = size === "md"
    ? "text-xs px-1.5 py-0.5 gap-1"
    : "text-[10px] px-1 py-[1px] gap-0.5";
  return (
    <span
      className={`inline-flex items-center rounded-md border font-semibold ${style.cls} ${sizeCls}`}
      title={`${level.label} · Level ${level.level} · ${level.xp} XP`}
      data-testid={`level-badge-${level.level}`}
    >
      <span aria-hidden>{style.icon}</span>
      <span className="tabular-nums">L{level.level}</span>
      {showLabel && <span className="ml-0.5">{level.label}</span>}
    </span>
  );
}
